export const GET_NOTIFICATIONS = "notifications/all";
export const MARK_NOTI_AS_READ = (id) => `notifications/read/${id}`;
